import { createSelector } from '@ngrx/store';
import { TMachineMaintenanceState } from '../reducers';
import { TEmployeeManagementState } from './employee-management.models';

export const getEmployeeManagementState = (state: TMachineMaintenanceState) => state.employeeManagementInfo;

export const getEmployeeListInfo = createSelector(
  getEmployeeManagementState,
  (state: TEmployeeManagementState) => state.employeeListingInfo,
);

export const getPagination = createSelector(
  getEmployeeManagementState,
  (state: TEmployeeManagementState) => state.employeeListingPagination,
);

export const getDeleteEmployeeReplacements = createSelector(
  getEmployeeManagementState,
  (state: TEmployeeManagementState) => state.deleteEmployeeReplacementsFailure,
);
